import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosClient from 'libs/axios/axios';

const addSafetyMeasure = async (safetyMeasure: string) => {
  const { data } = await axiosClient.post('/safety-measure', {
    name: safetyMeasure,
  });

  return data;
};

const useAddSafetyMeasureQuery = () => {
  const queryClient = useQueryClient();

  return useMutation(['safetyMeasure', 'add'], addSafetyMeasure, {
    onSuccess: () => {
      queryClient.invalidateQueries(['safetyMeasure', 'list']);
    },
    onError: (error) => {
      alert('추가 실패. 다시 한 번 시도해주세요');
      console.error('add safetyMeasure error', error);
    },
  });
};

export default useAddSafetyMeasureQuery;
